import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchAllApartments } from "../../store/apartmentsSlice";

import ApartmentItem from "../../../../components/ApartmentItem/ApartmentItem";
import SortItem from "../SortItem/SortItem";

import { modifierPrice } from "../../../../helpers/modifierPrice";

import Skeleton from "../../../../components/Skeleton/Skeleton";

export const ApartmentsList = () => {
	const { apartments, loading } = useSelector((state) => state.apartments);
	const dispatch = useDispatch();
	
	const apartmentsRequest = async () => {
		dispatch(fetchAllApartments());
	}
	
	useEffect(() => {
		apartmentsRequest();
	}, []);

	const skeleton = Array(20).fill('');
	
	return (
		<div className='apartments'>
			<SortItem />
			<ul>
				{apartments.length > 0 && !loading ?
					apartments.map((item) => {
						return (
							<li key={item.id}>
								<ApartmentItem {...item} modifyPrice={modifierPrice} />
							</li>
						)
					}) :
					skeleton.map((item, index) => {
						return (
							<Skeleton key={index} />
						);
					})
				}
			</ul>
		</div>
	);
};
